import AmexGDAHero from './AmexGDAHero';

export default AmexGDAHero;
